import { useQuery } from "@apollo/client";
import { sortBy } from "lodash";

import { ListStaffEmailsQuery } from "~frontend/__generated__/graphql";
import { LIST_STAFF_EMAILS } from "~frontend/graphql/staffEmails";

const prioritizeEmails = (emailList: any[], priorityEmails: any[]) =>
  emailList.sort((a, b) => {
    const aPriority = priorityEmails.includes(a.email) ? 0 : 1;
    const bPriority = priorityEmails.includes(b.email) ? 0 : 1;
    return aPriority - bPriority;
  });

export const useStaffEmails = (): {
  loading: boolean;
  error: Error | undefined;
  data: ListStaffEmailsQuery["listStaffEmails"];
  prioritizeEmails: (emailList: any[], prioritizeEmails: any[]) => any[];
} => {
  const { data, loading, error } =
    useQuery<ListStaffEmailsQuery>(LIST_STAFF_EMAILS);

  return {
    loading,
    error,
    data: data ? sortBy(data.listStaffEmails, "fullName") : [],
    prioritizeEmails,
  };
};
